import React from "react";
import { ConsolidationExportCard } from "./ConsolidationExportCard";
import { ConsolidationExportUIProvider } from "./ConsolidationExportUIContext";

export function ConsolidationExportPage({ history, match }) {
  const ConsolidationExportUIEvents = {
    newConsolidationExportButtonClick: () => {
      history.push("/admin/ConsolidationExport/new");
    },
    openEditConsolidationExportPage: id => {
      history.push(`/admin/ConsolidationExport/${id}/detail`);
    },
    openConsolidationExportFilePage: id => {
      history.push(`/admin/ConsolidationExport/file/${id}`);
    }
  };

  return (
    <ConsolidationExportUIProvider
      ConsolidationExportUIEvents={ConsolidationExportUIEvents}
    >
      <ConsolidationExportCard history={history} match={match} />
    </ConsolidationExportUIProvider>
  );
}
